import Service from "../../Service";

const resource = "HmnPublicRecruitment/";

export default {
  pagination(dtr, requestID) {
    return Service.post(resource + "paginate", dtr, {
      params: { requestID: requestID },
    });
  },
  paginate(dtr, requestID) {
    return Service.post(resource + "paginate", dtr, {
      params: { requestID: requestID },
    });
  },
  list(requestID, mrcID = null) {
    return Service.post(resource + "list", null, {
      params: { requestID: requestID, ...(mrcID ? { MrcID: mrcID } : {}) },
    });
  },
  save(item, requestID) {
    return Service.post(resource + "save", item, {
      params: { requestID: requestID },
    });
  },
  publicSave(item, recaptchaToken) {
    return Service.post(resource + "public-save", {
      item,
      recaptchaToken,
    });
  },
  verifyRecaptcha(recaptchaToken) {
    return Service.post(resource + "verify-recaptcha", {
      recaptchaToken,
    });
  },
  bulkSelect(payload, requestID) {
    return Service.post(resource + "bulk-select", payload, {
      params: { requestID: requestID },
    });
  },
  setStatus(pmaID, pmaStatus, requestID) {
    return Service.post(resource + "set-status", null, {
      params: { pmaID, pmaStatus, requestID },
    });
  },
  getByDocument(document, requestID) {
    return Service.get(resource + "by-document", {
      params: { document, requestID },
    });
  },
  getApplicantPosition(document, requestID) {
    return Service.get(resource + "applicant-position", {
      params: { document, requestID },
    });
  },
};
